<template>
  <div v-if="category" class="category">
    <tabs v-if="!selectedNominee" @changeCategory="clearSelectedId" />

    <div v-if="selectedNominee" class="selection">
      <h1 class="title" style="color: #faf9f6; text-decoration: underline; margin: auto">Jouw keuze(s)</h1>
      <selection />

      <router-link class="button" :to="{ name: 'submit' }"> Stemmen afronden </router-link>
    </div>

    <template v-else>
      <div style="justify-content: space-between; display: inline-flex">
        <h1 class="title" style="color: #faf9f6">{{ category.name }}</h1>
        <a v-if="allowSuggestions" @click="showSuggestionModal = true" class="suggestion__button">
          Voeg hier zelf een suggestie toe
        </a>
      </div>

      <div class="grid" ref="grid" v-if="filteredNominees.length" :key="category.id">
        <div
          :class="classForGridItem(nominee)"
          v-for="nominee in filteredNominees"
          :style="stylesForNominee(nominee)"
          style="text-align: center; align-content: end"
          :key="nominee.id"
          role="button"
          tabindex="0"
          @click="select(nominee)"
          :title="nominee.name"
        >
          <b style="color: #faf9f6; font-size: 80%">{{ nominee.name }}</b
          ><br />
          <b style="color: #faf9f6; font-size: 60%" v-if="nominee.platform">{{ nominee.platform }}</b>
        </div>
      </div>

      <p style="color: #faf9f6" v-else>Er zijn geen genomineerden gevonden binnen de opgegeven criteria.</p>

      <div class="floating-button">
        <button class="button" :disabled="!canVote" v-if="filteredNominees.length" @click="vote">
          Stem nu
        </button>
      </div>
    </template>
    <suggestion-modal
      v-if="showSuggestionModal"
      :category-id="category.id"
      @closeModal="showSuggestionModal = false"
    />
  </div>

  <p v-else>
    Deze pagina bestaat niet (meer).
    <router-link :to="{ name: 'home' }">Klik hier om terug te keren naar de homepage</router-link>.
  </p>
</template>

<script>
import Tabs from '@/components/Tabs'
import Selection from '@/components/Selection'
import SuggestionModal from '@/components/SuggestionModal'

export default {
  name: 'Category',

  components: {
    tabs: Tabs,
    selection: Selection,
    suggestionModal: SuggestionModal,
  },

  props: {
    categorySlug: {
      type: String,
      required: true,
    },

    nomineeId: {
      type: Number,
      required: false,
    },
  },

  data() {
    return {
      selectedId: null,
      showSuggestionModal: false,
    }
  },

  methods: {
    select(nominee) {
      this.selectedId = nominee.id
    },

    vote() {
      const { category, selectedId } = this

      if (selectedId && category) {
        this.$store.dispatch('selectNominee', { categoryId: category.id, nomineeId: selectedId })
      }
    },

    clearCategory() {
      this.$store.dispatch('clearCategory', {
        categoryId: this.category.id,
      })
    },

    stylesForNominee(nominee) {
      return nominee.image
        ? {
            backgroundImage: `linear-gradient(0deg, #121212, transparent), url(${nominee.image})`,
          }
        : {}
    },

    classForGridItem(nominee) {
      return {
        grid__item: true,
        'grid__item--selected': nominee.id === this.selectedId,
      }
    },

    urlForCategory(category) {
      return {
        name: 'category',
        params: {
          categorySlug: category.slug,
        },
      }
    },

    urlForNominee(nominee) {
      return {
        name: 'nominee',
        params: {
          categoryId: this.category.id,
          nomineeId: nominee.id,
          nomineeSlug: nominee.slug,
        },
      }
    },

    classForNominee(nominee) {
      return {
        item: true,
        'item--nominee': true,
        'item--disabled': this.activeNominee && !(this.activeNominee.id === nominee.id),
        'item--selected': this.isSelectedNominee(nominee),
      }
    },

    isSelectedNominee(nominee) {
      return this.selected.find(({ nomineeId }) => nomineeId === nominee.id)
    },

    hasSelectedNominee(category) {
      return this.selected.find(({ categoryId }) => categoryId === category.id)
    },

    clearSelectedId() {
      if (this.selectedId != null) {
        this.selectedId = null
      }
    },
  },

  computed: {
    selectedItem() {
      return this.filteredNominees.find((item) => item.id === this.selectedId)
    },

    canVote() {
      return this.selectedItem != null
    },

    selected() {
      return this.$store.state.selected
    },

    suggestions() {
      return this.$store.state.suggestions
    },

    loaded() {
      return this.$store.state.loaded
    },

    selection() {
      return this.$store.getters.selection.map(({ nominee }) => nominee).filter((nominee) => nominee)
    },

    canAdd() {
      return this.$store.getters.selection.length > this.selection.length
    },

    selectedNominee() {
      const selected = this.selected.find(({ categoryId }) => categoryId === this.category.id)
      const searchNominee = selected
        ? this.nominees.find((nominee) => nominee.id === selected.nomineeId)
        : null

      if (!searchNominee) {
        return selected
          ? this.suggestions.find((suggestion) => suggestion.categoryId === selected.categoryId)
          : null
      } else {
        return searchNominee
      }
    },

    categories() {
      return this.$store.state.categories
    },

    category() {
      return this.categories.find(({ slug }) => slug === this.categorySlug)
    },

    nominees() {
      return this.$store.getters.getNomineesByCategoryId(this.category.id)
    },

    activeNominee() {
      return this.nomineeId ? this.filteredNominees.find(({ id }) => id === this.nomineeId) : null
    },

    filteredNominees() {
      return this.$store.getters.getFilteredNomineesByCategoryId(this.category.id)
    },

    allowSuggestions() {
      return this.$store.state.allowSuggestions
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Category.vue